<template>
  <div>
    <ValidationObserver ref="form">
      <div class="row mb-3">
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required|onlyNumbers">
            <input
              type="text"
              class="form-control"
              placeholder="CNES"
              v-model="form.cnes"
              v-inputmask="maskNumbers"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="monthOptions"
              label="label"
              placeholder="Mês"
              v-model="form.mes"
              @input="onChangeMonth($event)"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required|onlyNumbers">
            <input
              type="text"
              class="form-control"
              placeholder="Ano"
              v-model="form.ano"
              v-inputmask="maskNumbers"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <button class="btn" @click="buscar()">Buscar</button>
        </div>
      </div>
    </ValidationObserver>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div class="info-table-item">
            <download-files
              :callback-pdf="generatePdf"
              :data="displayedCadastros"
              :xlsEnabled="false"
              name="Cadastros-bpac"
            >
            </download-files>
          </div>
        </div>
        <tabela-cadastros
          ref="table"
          :cadastros="displayedCadastros"
          :loading="loading"
          @filterSearch="filterSearch($event)"
        ></tabela-cadastros>
      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  name: 'RAS',
  components: {
    TabelaCadastros,
    Selects,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  data() {
    return {
      equipe: '',
      cadastros: [],
      totalItems: 0,
      loading: false,
      equipName: '',
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      month: '',
      disabledMonth: true,
      cadastrosOriginais: [],
      filterSearchTable: false,
      form: {
        cnes: '',
        mes: '',
        ano: '',
      },
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Retorna o mês atual
     *
     * @returns {String}
     */
    getCurrentMonth() {
      const date = new Date()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return month
    },

    /**
     * Busca os dados
     */
    async buscar() {
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        this.loading = true
        const response = await Functions.getDados(
          this.$store.state.cod_ibge,
          this.form.cnes,
          this.form.mes.value,
          this.form.ano
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response

          this.totalItems = response.length
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
      }

      return
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.form.cnes,
        this.form.mes.value,
        this.form.ano
      )
    },
  },
}
</script>

<style></style>
